import React, {FunctionComponent} from 'react';
import {MenuList, SwipeableDrawer} from '@material-ui/core';
import NavMenuItem, {NavMenuItemData} from '@treez-ui/core/header/NavMenuItem';

interface Props {
    menuItems?: NavMenuItemData[];
    menuItemsDash?: NavMenuItemData[];
    onClose: () => void;
    open: boolean;
}

export const NavigationMenu: FunctionComponent<Props> = (props: Props) => {
    const {menuItems = [], menuItemsDash = [], onClose, open} = props;

    return (
        <>
            <SwipeableDrawer
                open={open}
                onClose={(): void => {
                    onClose();
                }}
                onOpen={(): void => {}}
                BackdropProps={{invisible: true}}
                className="menu-drawer"
            >
                <MenuList className="menu-list">
                    {menuItems.map((menuItemData, idx) => (
                        <NavMenuItem {...menuItemData} key={idx} onCloseMenu={onClose} />
                    ))}
                </MenuList>
            </SwipeableDrawer>
            <SwipeableDrawer
                open={open}
                onClose={(): void => {
                    onClose();
                }}
                onOpen={(): void => {}}
                BackdropProps={{invisible: true}}
                className="menu-drawer-dash"
            >
                <MenuList className="menu-list menu-list-dash">
                    {menuItemsDash.map((menuItemData, idx) => (
                        <NavMenuItem {...menuItemData} key={idx} onCloseMenu={onClose} />
                    ))}
                </MenuList>
            </SwipeableDrawer>
        </>
    );
};
